"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
const alert_context_1 = require("./alert.context");
const useAlert = () => {
    const { state, dispatch } = (0, alert_context_1.useAlertContext)();
    const alerts = state.alerts;
    const addSuccessAlert = (alert) => {
        return addAlert({ ...alert, status: 'success' });
    };
    const addErrorAlert = (alert) => {
        return addAlert({ ...alert, status: 'error' });
    };
    const addAlert = (alert) => {
        dispatch(alert_context_1.AlertAction.addAlert({ ...alert, id: alert.id ?? Math.floor(Math.random() * 1000000).toString() }));
    };
    const removeAlert = (alert) => {
        dispatch(alert_context_1.AlertAction.removeAlert(alert));
    };
    return {
        alertList: alerts,
        addSuccessAlert,
        addErrorAlert,
        removeAlert,
    };
};
exports.useAlert = useAlert;
